import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
    isNotificationBarDisabled: false,
    startDate: "",
    endDate: "",
    notificationText: "",
    urlLink: "",
};

export const NotificationBarManagementFormData = {
    name: "Notification Bar Management FormData",
    initialState: initState,
    section: [
        {
            title: "Notification Bar",
            row: {},
            style: {
                sectionStyle: "vertical-form mb-3 form-card row",
            },
            wrapperTemplate: <TitleWrapper title="Notification Bar" />,
            fields: [
                {
                    id: "isNotificationBarDisabled",
                    label: "Disable Notification Bar",
                    Field_Name: "Disable Notification Bar",
                    fieldType: FormFieldTypes.SWITCH,
                    dataField: "isNotificationBarDisabled",
                    fieldSetting: {
                        options: [],
                    },
                    style: {
                        containerCss:
                            "col-lg-12 col-md-12 radioStyle  mb-2 normal-checkbox",
                    },
                },
                {
                    id: "startDate",
                    label: "Start Date",
                    Field_Name: "Start Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "startDate",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "endDate",
                    label: "End Date",
                    Field_Name: "End Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "endDate",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "notificationText",
                    label: "Notification Text",
                    Field_Name: "Notification Text",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "notificationText",
                    fieldSetting: {
                        placeholder: "Please Enter Notification Text",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0 ",
                    },
                },
                {
                    id: "urlLink",
                    label: "URL Link",
                    Field_Name: "URL Link",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "urlLink",
                    fieldSetting: {
                        placeholder: "Please Enter URL Link",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0 ",
                    },
                },
            ],
        },

    ],
};
